import './spinner.scss';

const Spinner = () => (
  <div className="spinner">
    <figure className="loader-figure">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </figure>
  </div>
);

export default Spinner;
